module.exports = __webpack_public_path__ + "static/GlitchlessSonyax46-1ed2b39e2b75f832030136f5209af0fd.png";